import React, { useState } from 'react';
import { Card, Image, Button, Grid, Segment, Icon, List, Header, Container, Label, Modal,Divider } from 'semantic-ui-react';
import Head from 'next/head';
import { withNamespaces, Link } from '../i18n';
import actions from '../constants/actions.json';

const CollectAction = ({ t, i18n }) => {
	return (
		<div>
			<Head>
				<title>CollectAPI - {t('collectActionTitleHead')}</title>
				<style>{`
          .circular-image {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            overflow: hidden;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .circular-image img {
            width: 60%;
            height: auto;
          }
        `}</style>
			</Head>
			<div style={{ marginTop: '2em', marginBottom: '2em' }}>
				<Header as="h1" textAlign="center">
					CollectAction
				</Header>

				<Header as="h3" textAlign="center">
					{t('siradisi_deneyim')}
				</Header>
				<Divider />
			</div>
			<Grid style={{ marginTop: '20px', marginBottom: '20px' }} container stackable columns={3}>
				{actions.map(action => (
					<Grid.Column key={action.id}>
						<Card style={{ minHeight: '100%' }} fluid>
							<Card.Content>
								<div className="circular-image">
									<img src={action.settings.image['en']} alt={action.settings.title[i18n.language]} />
								</div>
								<Card.Header style={{ marginTop: '10px', textAlign: 'center' }}>{action.settings.title[i18n.language]}</Card.Header>
								<Card.Description style={{ textAlign: 'center' }}>{action.settings.description[i18n.language]}</Card.Description>
							</Card.Content>
							<Card.Content extra>
								<div style={{ display: 'flex', width: '100%', gap: '4px' }}>
									<a
										href={
											action.settings.slug[i18n.language] === 'RetentionTab'
												? 'https://retentiontab.com/'
												: i18n.language === 'en'
												? `https://collectaction.com/en/action/${action.settings.slug[i18n.language]}`
												: `https://collectaction.com/action/${action.settings.slug[i18n.language]}`
										}
										target="_blank"
										rel="noopener noreferrer"
									>
										<Button style={{ width: '100%' }} primary>
											{t('kesfetButton')}
										</Button>
									</a>

									<a style={{ flex: 1, textAlign: 'center' }} href={`/action/${action.settings.slug[i18n.language]}`}>
										<Button style={{ width: '100%' }} secondary>
											{t('FeaturesButton')}
										</Button>
									</a>
								</div>
							</Card.Content>
						</Card>
					</Grid.Column>
				))}
			</Grid>
			<Divider />
			<div class="container">
				<Segment vertical>
					<Header as="h2">{t('collectActionTitleHead')}</Header>
					<p>{t('collectactionBodyDescription')}</p>
				</Segment>

				<Segment vertical>
					<Header as="h2">{t('neden_collect_action')}</Header>
					<List relaxed>
						<List.Item>
							<Icon name="shield" />
							<List.Content>
								<List.Header>{t('kvkk_uyumlu')}</List.Header>
								<List.Description>{t('kvkk_uyumlu_description')}</List.Description>
							</List.Content>
						</List.Item>
						<List.Item>
							<Icon name="settings" />
							<List.Content>
								<List.Header>{t('ozellestirilebilir_yapi')}</List.Header>
								<List.Description>{t('ozellestirilebilir_yapi_description')}</List.Description>
							</List.Content>
						</List.Item>
						<List.Item>
							<Icon name="rocket" />
							<List.Content>
								<List.Header>{t('kolay_kurulum')}</List.Header>
								<List.Description>{t('kolay_kurulum_description')}</List.Description>
							</List.Content>
						</List.Item>
					</List>
				</Segment>
			</div>
			<Divider />
		</div>
	);
};

CollectAction.getInitialProps = async () => {
	return { namespacesRequired: ['common'] };
};

export default withNamespaces()(CollectAction);
